import React from 'react';
import ButtonType from './type';
import styles from './styles';
import { IPropsWithChildren, IPropsWithClassName } from 'interfaces';

export interface ButtonProps<DataType = any>
  extends IPropsWithChildren,
    IPropsWithClassName {
  type?: ButtonType;
  active?: boolean;
  icon?: React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  legend?: string;
  data?: DataType;
}

const Button = ({
  type = ButtonType.PRIMARY,
  active = false,
  icon: Icon,
  children,
  className,
  legend,
  ...props
}: ButtonProps & React.HTMLProps<HTMLButtonElement>) => {
  const componentStyles = styles.component(
    type,
    className,
    Boolean(props.disabled),
    active
  );

  return (
    <button type="button" className={componentStyles} {...props}>
      <div className={styles.iconContainer(Boolean(Icon))}>
        {Icon && <Icon className={styles.icon} />}
        {children}
      </div>
      {legend && <p className={styles.legend}>{legend}</p>}
    </button>
  );
};

export default Button;
